<style scoped>
    .top {
        padding-bottom: .38rem;
        font-size: .32rem;
        color: #000;
    }

    .num{
        margin-bottom: .32rem;
    }

    .progress {
        width: 6.74rem;
        height: .08rem;
        background: #F5F5F5;
        border-radius: .04rem;
    }

    .now {
        height: .08rem;
        background: #408BFB;
        border-radius: .04rem;
    }

    .content {
        width: 6.74rem;
        padding: .5rem .5rem;
        margin-top: .3rem;
        background: #FFFFFF;
        border: 1px solid rgba(230, 230, 230, 0.4);
        box-shadow: 0 .16rem .32rem 0 rgba(31, 33, 51, 0.05);
        border-radius: .08rem;
        margin-bottom: 1.4rem;
    }

    .questionBox {
        font-size: .32rem;
        color: #181818;
        line-height: .4rem;
        margin-bottom: 1rem;
    }

    .option {
        display: flex;
        align-items: center;
        padding: .28rem .4rem;
        box-sizing: border-box;
        background: #F5F5F5;
        border-radius: .48rem;
        margin-bottom: .26rem;
        font-size: .32rem;
        color: #4D4D4D;
        line-height: .36rem;
    }

    .option.active{
        background: #408BFB;
        color: #fff;
    }

    .optionContent{
        line-height: .4rem;
    }

    .option:last-child{
        border-bottom: none;
    }

    .option .icon {
        min-width: .24rem;
        height: .24rem;
        background: url("~assets/option.png") no-repeat center/cover;
        margin-right: .1rem;
        margin-left: .1rem;
    }

    .option .icon.active {
        background: url("~assets/option2.png") no-repeat center/cover;
    }

    .btnBox {
        width: 6.74rem;
        height: .88rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .32rem;
        /*font-weight: bold;*/
        color: #fff;
        background: #408BFB;
        border-radius: .44rem;
        /*margin-left: .24rem;*/
    }

    .sendBox {
        display: flex;
        justify-content: space-between;
        width: 6.74rem;
        /*margin-left: .48rem;*/
    }

    .sendBox div {
        width: 2.8rem;
        height: .8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #408BFB;
        color: #fff;
        border-radius: .4rem;
    }
</style>
<template>
    <div style="padding-top: 1rem;">
        <topbar text="测试题"></topbar>
        <div style="padding: .38rem">
            <div class="top">
                <div class="num" v-if="scaleInfoQuestionList&&questionNum">问题
                    {{scaleInfoQuestionList[questionNum - 1].question.questionNum}}/{{count}}
                </div>
                <div class="progress">
                    <div class="now" :style="{width:`${(questionNum/count)*6.74}rem`}"></div>
                </div>
            </div>
            <div class="content">
                <div class="questionBox" v-if="scaleInfoQuestionList&&questionNum">
                    {{questionNum}}、{{scaleInfoQuestionList[questionNum - 1].question.content}}
                </div>
                <ul class="questionOptions" v-if="scaleInfoQuestionList[questionNum-1] != undefined">
                    <li class="option" v-for="(item,index) in scaleInfoQuestionList[questionNum-1].questionOptions"
                        @click="next(item.optionId,item.questionNum)"  :class="{active:selectOption==item.optionId}">
                        <div class="optionContent">
                            {{item.optionType | isOption}} . {{item.content}}
                        </div>
<!--                        <div class="icon" :class="{active:selectOption==item.optionId}"></div>-->
                    </li>
                </ul>
            </div>
            <div class="sendBox" v-if="scaleInfoQuestionList.length>1&&(moreStatus||scaleInfoQuestionList[scaleInfoQuestionList.length-1].optionIds)">
                <div class="prev" @click="prev">上一题</div>
                <div class="send" @click="send">提交</div>
            </div>
            <div class="btnBox" v-if="!moreStatus&&(questionNum>1&&!scaleInfoQuestionList[scaleInfoQuestionList.length-1].optionIds)" @click="prev">
                上一题
            </div>
            <div class="btnBox" v-if="scaleInfoQuestionList[scaleInfoQuestionList.length-1].optionIds&&scaleInfoQuestionList.length===1" @click="send">
                提交
            </div>

        </div>
        </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'
    import Vue from "vue";

    import {Swiper, Slide} from 'vue-swiper-component';
    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                scaleId: '',
//                now: 0.2,
                scaleInfoQuestionList: [
                    {
                        question: {},
                        questionOptions: [],
                    }
                ],
                count: '',
                questionNum: '',
                selectOption: '',
                middle:'',
                testId:'',
                moreStatus:false,
                userId:'',
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
            isOption(value) {
                let arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q']
                return arr[value]
            },
        },
        computed: {},
        methods: {
            next(id, num) {
//                if(this.questionNum==thius.count){}
                this.selectOption = id;
                this.scaleInfoQuestionList[this.questionNum - 1].optionIds=id;

                if (num) {
                    this.middle=this.questionNum
                    if(num > this.count){
                        this.moreStatus=true;
                    }else{
                        this.moreStatus=false;
                        this.questionNum = num;
                        this.scaleInfoQuestionList[this.questionNum - 1].num=this.middle;
                        if(this.questionNum==this.count){
                            this.scaleInfoQuestionList[this.questionNum - 1].num=this.middle;
                        }
                    }
                } else if (this.questionNum < this.count) {
                    this.moreStatus=false;
                    this.middle=this.questionNum
                    this.questionNum++;
                    this.scaleInfoQuestionList[this.questionNum - 1].num=this.middle;
                    if(this.questionNum==this.count){
                        this.scaleInfoQuestionList[this.questionNum - 1].num=this.middle;
                    }
                } else if(this.questionNum == this.count) {
                    this.moreStatus=false;
                    this.scaleInfoQuestionList[this.questionNum - 1].num=this.middle;
                }else{
                    alert('出错了')
                }


            },
            selectPayType(n) {
                this.choose = n
            },
            prev() {
                console.log(this.questionNum)
                this.moreStatus=false;
                this.scaleInfoQuestionList[this.questionNum - 1].optionIds='';
                this.middle=this.questionNum
                this.questionNum=this.scaleInfoQuestionList[this.questionNum - 1].num;
                this.scaleInfoQuestionList[this.middle - 1].num='';
//                选中状态
                console.log(this.questionNum)
                this.selectOption = this.scaleInfoQuestionList[this.questionNum - 1].optionIds;


            },
            async send() {
                let obj = {}
                // obj.gender = this.$route.query.gender;
                obj.testId = this.testId;
                let str = '';
                this.scaleInfoQuestionList.forEach(v => {
                    if(v.optionIds){
                        str += v.optionIds + ','
                    }

                })
                str = str.slice(0, str.length - 1)
                console.log(str)
                obj.optionIds = str;
                let data = await getSources("/bear-scale/api/scaleInfoQuestion/commitScaleQuestionResult.json", obj);
                if (data.status === 0) {
                    if(this.$route.query.groupId){
                        this.$router.push(`/testResult?comboId=${this.$route.query.comboId}&groupId=${this.$route.query.groupId}`)
                    }else{
                        this.$router.push(`/result?testId=${this.testId}`)
                    }

                }else{
                    alert(data.msg)
                }
            },
            to(n) {
                this.$router.push(`/${n}`)
            },

            async getScaleInfo() {
                let obj = {}
                obj.scaleId = this.scaleId;
                obj.userId = this.userId;
                obj.testId = this.$route.query.testId;
                let data = await getSources("/bear-scale/api/scaleInfoQuestion/getScaleQuestionList.json", obj);
                if (data.status === 0) {
                    this.scaleInfoQuestionList = data.scaleInfoQuestionList;
                    if(data.scaleInfoQuestionList.length>0){
                        this.questionNum = data.scaleInfoQuestionList[0].question.questionNum;
                    }
                    this.count = data.count;
                    this.testId = data.testId;

                    this.scaleInfoQuestionList.forEach(item => {
                        //checkBox
                        Vue.set(item, "optionIds", '');
                        Vue.set(item, "num", '');
                    });
                }else{
                    alert(data.msg)
                }
            },

            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            }
        },
        mounted() {
            this.scaleId = this.$route.query.scaleId;
            this.userId = localStorage.getItem('userId');
            this.getScaleInfo()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/topic.vue?ca290fb4